import { FaArrowRight } from "react-icons/fa";
import { useNavigateAndScroll } from "../../../../hooks/useNavigateAndScroll";

export const SmartChoices = () => {
  const navigateAndScroll = useNavigateAndScroll();
  return (
    <section className="meet-wrapper" style={{ marginTop: "8rem" }}>
      <div
        className="meet-box"
        style={{
          backgroundColor: "var(--blue-highlight)",
          color: "white",
        }}
      >
        <p className="meet-title">Tomá decisiones inteligentes</p>
        <p className="color-card-subtitle">
          Sin tareas manuales ni rutinarias que demanden mucho tiempo.
        </p>
        <span className="horizontal gap-16">
          <button
            className="boton-generico boton-azul"
            style={{ borderColor: "white" }}
            onClick={() => navigateAndScroll("/business-intelligence")}
          >
            <p>Mirá cómo funciona</p>
            <FaArrowRight />
          </button>
          <a
            download
            href="https://binamics.com.ar/brochures/presentacion_empresarial_binamics.pdf"
            style={{ textDecoration: "none" }}
            target="_blank"
            rel="noreferrer"
          >
            <button
              className="boton-generico boton-azul"
              style={{ borderColor: "white" }}
            >
              <p>Descargá el PDF de BI</p>
              <FaArrowRight />
            </button>
          </a>
        </span>
      </div>
      <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/imgBI-16.png`}
        alt="bi"
        className="bi-image"
        style={{ width: "25%", bottom: "-60%" }}
      />
    </section>
  );
};
